import React, { useEffect } from "react";
import "../../components/Cart/Cart.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import { AiOutlineMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { deleteCart, getCartDetails } from "../../Redux/Actions";
import { useDispatch , useSelector } from "react-redux";
import { connect } from "react-redux";
import { SMS_VERIFICATION_CANCEL_SUCCESS } from "../../Redux/Constants";

// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const PackageInfo = (props) => {
  const { Review, cartData } = props
  const { package: cart } = cartData && cartData;
  
  const Mrp = cart.package_center_address_prices?.package_price;
  const offerPrice = cart.package_center_address_prices?.offer_price;
  const discount = Mrp - offerPrice;
  const finalPrice = Mrp - discount;

  var discountPercentage = Math.ceil((discount / Mrp) * 100);
  const dispatch = useDispatch();

  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;

  console.log(props.AddonState,"ON PACKAGE ADDON ")

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    dispatch(getCartDetails(token , citySelect && citySelect ));
  };
  const deleteItem = (id) => {
    console.log(id, "cart id to be deleted");

    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;

    dispatch(deleteCart(token, id, successCb));

    // toast.error("Package successfully removed from cart", {
    //   position: "bottom-right",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
  };

  return (
    <>
    <div className="box">
      {console.log("this is cart data", cart?.parameter > 1)}
      <div className="flexDirect paddng_2 borderBtm">
        <h2 className="textblueBold" style={{width:"90%"}}>{cart?.name}</h2>
        {Review ? null : (
          <RiDeleteBin6Line 
               
            onClick={() => deleteItem(cartData?.id)}
            style={{ cursor: "pointer" , color:"red" , fontSize: "2rem" }}
          />
        )}
      </div>
      <div className="">
        <div style={{ marginTop: "1rem" }}>
    
          
          <p className="paddng_2">{cart?.description}</p>
        </div>

        <div className="flexDirect" style={{    borderTop: "1px solid gainsboro"}}>
          <div className="price_info">
            <span
              className="textpink"
              style={{ textDecoration: "line-through" }}
            >
              Rs.{cart?.package_center_address_prices?.package_price ? cart?.package_center_address_prices?.package_price : cart?.package_price}/-
            </span>
            <span className="textblueBold">Rs. {cart?.package_center_address_prices?.offer_price ? cart?.package_center_address_prices?.offer_price : cart?.offer_price }/-</span>
            <span className="btn_neon">Get {discountPercentage}  % OFF</span>
          </div>
          {/* {Review ? (
            <div className="price_info">
              <span className="plusMinus">
                <AiOutlineMinusCircle />
                45
                <AiFillPlusCircle />
              </span>
            </div>
          ) : null} */}
          
        </div>
      </div>
    </div>
    {/* <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ fontSize: "1.8rem" }}
      /> */}
    </>
  );
};
const mapStateToProps = (state) => ({
  AddonState: state?.AddonSetter?.Addon

});

const mapDispatchToProps = (dispatch) => {
  return {
    
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(React.memo(PackageInfo))

